/**
 * Builds a safe export filename: `patchprobe-<slugged-parts>.json`.
 * Parts are joined with `-`; characters outside [a-z0-9.@_-] collapse to `-`.
 */
export function exportFilename(...parts: string[]): string {
  const slug = parts
    .join('-')
    .toLowerCase()
    .replace(/[^a-z0-9.@_-]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-+|-+$/g, '');
  return `patchprobe-${slug}.json`;
}

/**
 * Serializes `data` inside a small PatchProbe envelope and triggers a browser
 * file download. The envelope records what was exported and when, so the file
 * is self-describing outside the app.
 */
export function downloadJson(filename: string, kind: string, data: unknown): void {
  const payload = {
    tool: 'PatchProbe',
    kind,
    exportedAt: new Date().toISOString(),
    data,
  };
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
